const environmentPartitionIdMap = {
  dev: '1',
  qa: '1',
  beta: 'EZTd78o4Sy2gm-eirfKkxQ',
  production: '7LVQbH2KR4C6hKHZo9xwig'
}

export default environmentPartitionIdMap


// WEBPACK FOOTER //
// ./src/lib/partitionIdMap/partitionIdMap.js